import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  showArrow?: boolean;
  className?: string;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  showArrow = true,
  className = ''
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const sharedClassName = `group inline-flex items-center justify-center gap-2 ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-xl bg-action font-heading font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-action-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary ${className}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon size={size === 'lg' ? 20 : 18} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-261" data-mp="grggwizooys2" />}
    </>;
  if (href) {
    return <a href={href} onClick={onClick} className={sharedClassName} data-id="element-262" data-mp="bsdkto1om2w8">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={sharedClassName} data-id="element-263" data-mp="prll6k9kzh20">
      {content}
    </button>;
}